import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/home-editorial-note")({
  component: lazyRouteComponent(() => import("./-pages/admin.home-editorial-note")),
  head: () => ({
    meta: [
      { title: "بلوك ٦ — إدارة" },
      {
        name: "description",
        content: "خطّ فاصل بنصّ مركزيّ بين بلوكات الصفحة الرئيسيّة.",
      },
    ],
  }),
});
